import React from 'react'
import { ReadershipProfileInputTypeInterface } from '../configs/StudiesObjectsCompareGroupTypesConfig'
import { BookInterface } from '../../../../../core/interface/book.interface'
import InputTypeChoice from '../../../../share/InputTypeChoice'
import { DateFilterTypeEnum } from '../../../../../core/enums/date-filter-type.enum'
import NewReadershipProfileBookFiltersInterface from '../../../../../core/interface/analytics/new-readership-profile-book-filters'

const ReadershipProfileInputTypeChoice = <InputType, ValueType>({
  disable,
  keyValue,
  color,
  title,
  subTitle,
  inputsTypeConfig,
  inputTypeSelected,
  inputValue,
  handleOnClickInputSelectionButton,
  handleSelectValue,
  booksSelected,
  handleUpdateBooksSelected,
  handleOpenBookDetails,
  eanSelected,
  filtersActions,
  handleOnChangeFilter,
  isPrivate = false,
}: {
  disable: boolean
  keyValue: string
  color: string
  title: string
  subTitle: string
  inputsTypeConfig: ReadershipProfileInputTypeInterface<InputType>[]
  inputTypeSelected: InputType
  handleOnClickInputSelectionButton: (type: InputType) => void
  inputValue: ValueType
  handleSelectValue: (type: ValueType) => void
  booksSelected: BookInterface[]
  handleUpdateBooksSelected: (books: BookInterface[]) => void
  handleOpenBookDetails: (eanId: number | null) => void
  eanSelected: number | null
  filtersActions: NewReadershipProfileBookFiltersInterface
  handleOnChangeFilter: (
    key: string | number,
    newList: Array<string | number | null> | DateFilterTypeEnum,
  ) => void
  isPrivate?: boolean
}) => {
  return (
    <div className="relative basis-1/2 h-full flex flex-col gap-4 p-8">
      <InputTypeChoice<InputType, ValueType>
        disable={disable}
        color={color}
        keyValue={keyValue}
        title={title}
        subTitle={subTitle}
        inputsTypeConfig={inputsTypeConfig}
        inputTypeSelected={inputTypeSelected}
        inputValue={inputValue}
        handleOnClickInputSelectionButton={handleOnClickInputSelectionButton}
        handleSelectValue={handleSelectValue}
        booksSelected={booksSelected}
        handleUpdateBooksSelected={handleUpdateBooksSelected}
        handleOpenBookDetails={handleOpenBookDetails}
        eanSelected={eanSelected}
        filtersActions={filtersActions}
        handleOnChangeFilter={handleOnChangeFilter}
        isPrivate={isPrivate}
      />
    </div>
  )
}

export default ReadershipProfileInputTypeChoice
